import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
const defaultOptions = {} as const;

export type UpdateVehicleCargoItemMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateVehicleCargoItemInput;
}>;

export type UpdateVehicleCargoItemMutationResult = { __typename?: 'Mutation' } & {
  cargoUpdateVehicleCargoItem?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateVehicleCargoItemPayload' } & {
      cargoItem?: GraphQLTypes.Maybe<
        | ({ __typename?: 'CargoContainerType' } & Pick<
            GraphQLTypes.CargoContainerType,
            'cbm' | 'hazardous' | 'id' | 'looseCargoType' | 'quantity' | 'reefer' | 'type'
          > & {
              grossWeight?: GraphQLTypes.Maybe<
                { __typename?: 'CargoWeightType' } & Pick<GraphQLTypes.CargoWeightType, 'metric' | 'value'>
              >;
            })
        | ({ __typename?: 'CargoLooseCargoType' } & Pick<
            GraphQLTypes.CargoLooseCargoType,
            'cbm' | 'hazardous' | 'id' | 'looseCargoType' | 'quantity' | 'reefer' | 'type'
          > & {
              grossWeight?: GraphQLTypes.Maybe<
                { __typename?: 'CargoWeightType' } & Pick<GraphQLTypes.CargoWeightType, 'metric' | 'value'>
              >;
            })
        | ({ __typename?: 'CargoVehicleType' } & Pick<
            GraphQLTypes.CargoVehicleType,
            | 'healthCertificate'
            | 'palletType'
            | 'riskLevel'
            | 'tailLift'
            | 'trailerId'
            | 'vehicleType'
            | 'cbm'
            | 'hazardous'
            | 'id'
            | 'looseCargoType'
            | 'quantity'
            | 'reefer'
            | 'type'
          > & {
              dimensions?: GraphQLTypes.Maybe<
                { __typename?: 'CargoDimensionsType' } & Pick<
                  GraphQLTypes.CargoDimensionsType,
                  'height' | 'length' | 'metric' | 'width'
                >
              >;
              valueOfGoods?: GraphQLTypes.Maybe<{ __typename?: 'Money' } & Pick<GraphQLTypes.Money, 'currency' | 'value'>>;
              grossWeight?: GraphQLTypes.Maybe<
                { __typename?: 'CargoWeightType' } & Pick<GraphQLTypes.CargoWeightType, 'metric' | 'value'>
              >;
            })
      >;
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateVehicleCargoItemDocument = /*#__PURE__*/ gql`
  mutation updateVehicleCargoItem($input: UpdateVehicleCargoItemInput!) {
    cargoUpdateVehicleCargoItem(input: $input) {
      cargoItem {
        cbm
        grossWeight {
          metric
          value
        }
        hazardous
        id
        looseCargoType
        quantity
        reefer
        type
        ... on CargoVehicleType {
          dimensions {
            height
            length
            metric
            width
          }
          healthCertificate
          palletType
          riskLevel
          tailLift
          trailerId
          valueOfGoods {
            currency
            value
          }
          vehicleType
        }
      }
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useUpdateVehicleCargoItemMutation__
 *
 * To run a mutation, you first call `useUpdateVehicleCargoItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehicleCargoItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVehicleCargoItemMutation, { data, loading, error }] = useUpdateVehicleCargoItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVehicleCargoItemMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateVehicleCargoItemMutationResult, UpdateVehicleCargoItemMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<UpdateVehicleCargoItemMutationResult, UpdateVehicleCargoItemMutationVariables>(
    UpdateVehicleCargoItemDocument,
    options
  );
}
export type UpdateVehicleCargoItemMutationHookResult = ReturnType<typeof useUpdateVehicleCargoItemMutation>;
